import { AppCard } from "@lib/components/AppComponents";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { Form, Button, InputNumber, Slider, Typography, Divider } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";

const StyledSlider = styled(Slider)`
  .ant-slider-rail {
    background-color: ${({ theme }) => theme.palette.text.secondary};
  }
  .ant-slider-track {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`;

type IProps = {
  field: string;
  value?: string[];
  onFinish: (values: any) => void;
  filterOptions?: { text?: any; value?: any; label?: string }[];
  title?: string;
};

const NumberRangeFilter: React.FC<IProps> = ({
  field,
  value,
  onFinish,
  filterOptions,
  title,
}) => {
  const { messages } = useIntl();
  const [form] = Form.useForm();

  const min = Math.floor(filterOptions?.[0]?.value?.[0] || 0);
  const max = Math.floor(filterOptions?.[0]?.value?.[1] || 100) + 1;
  const [sliderValue, setSliderValue] = useState<number[]>([min, max]);

  useEffect(() => {
    form.setFieldValue("value", value?.map((v) => Number(v)) || [min, max]);
  }, [value]);

  return (
    <AppCard style={{ padding: "10px" }}>
      {title && <Typography.Text>{messages[title] as string}</Typography.Text>}
      {title && <Divider style={{ margin: "5px 0" }} />}
      <Form
        form={form}
        name={`number_range_search_filter_form_${field}`}
        autoComplete="off"
        className="table-action-form"
        onFinish={({ value }) => {
          onFinish({
            field,
            value: value.map((v) => v.toString()),
          });
        }}
      >
        <Form.Item style={{ marginBottom: 10 }} name="value">
          <StyledSlider
            range
            min={min}
            max={max}
            step={1}
            onChange={setSliderValue}
            marks={{ [min]: min, [max]: max }}
            defaultValue={sliderValue}
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 10 }}>
          <StyledFlex style={{ justifyContent: "space-between" }}>
            <InputNumber
              value={sliderValue[0]}
              onChange={(value) => setSliderValue([value, sliderValue[1]])}
            />
            <InputNumber
              value={sliderValue[1]}
              onChange={(value) => setSliderValue([sliderValue[0], value])}
            />
          </StyledFlex>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <StyledFlex style={{ justifyContent: "space-between" }}>
            <Button
              data-testid="reset"
              htmlType="reset"
              type="link"
              onClick={() => onFinish({ field, value: undefined })}
            >
              {messages["common.reset"] as string}
            </Button>
            <Button
              data-testid="submit"
              htmlType="submit"
              type="primary"
              loading={false}
            >
              {messages["common.submit"] as string}
            </Button>
          </StyledFlex>
        </Form.Item>
      </Form>
    </AppCard>
  );
};

export default NumberRangeFilter;
